import createIcon from '../../createIcon';

/**
 * @component @name CloudSync
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAxNC45OEMxOS40OCAxNC45OCAxOS40NyAxNC45OCAxOS40NSAxNC45OUMxOS4yIDEzLjMgMTcuNzYgMTIgMTYgMTJDMTQuNiAxMiAxMy40IDEyLjgzIDEyLjg0IDE0LjAyQzExLjI2IDE0LjEgMTAgMTUuNCAxMCAxN0MxMCAxOC42NiAxMS4zNCAyMCAxMyAyMEwxOS41IDE5Ljk4QzIwLjg4IDE5Ljk4IDIyIDE4Ljg2IDIyIDE3LjQ4QzIyIDE2LjEgMjAuODggMTQuOTggMTkuNSAxNC45OFpNOCA0LjI2VjYuMzVDNS42NyA3LjE4IDQgOS4zOSA0IDEyQzQgMTMuNzcgNC43OCAxNS4zNCA2IDE2LjQ0VjE0SDhWMjBIMlYxOEg0LjczQzMuMDYgMTYuNTQgMiAxNC40IDIgMTJDMiA4LjI3IDQuNTUgNS4xNSA4IDQuMjZaTTE4IDZIMTUuMjdDMTYuNyA3LjI2IDE3LjY4IDkuMDEgMTcuOTMgMTFIMTUuOTFDMTUuNjggOS42NCAxNC45OCA4LjQ1IDE0IDcuNTZWMTBIMTJWNEgxOFY2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CloudSync = createIcon('CloudSync', [
  [
    'path',
    {
      d: 'M19.5 14.98C19.48 14.98 19.47 14.98 19.45 14.99C19.2 13.3 17.76 12 16 12C14.6 12 13.4 12.83 12.84 14.02C11.26 14.1 10 15.4 10 17C10 18.66 11.34 20 13 20L19.5 19.98C20.88 19.98 22 18.86 22 17.48C22 16.1 20.88 14.98 19.5 14.98ZM8 4.26V6.35C5.67 7.18 4 9.39 4 12C4 13.77 4.78 15.34 6 16.44V14H8V20H2V18H4.73C3.06 16.54 2 14.4 2 12C2 8.27 4.55 5.15 8 4.26ZM18 6H15.27C16.7 7.26 17.68 9.01 17.93 11H15.91C15.68 9.64 14.98 8.45 14 7.56V10H12V4H18V6Z',
      key: 'po4048',
    },
  ],
]);

export default CloudSync;
